import * as StringUtils from "./StringUtils";

export interface PortalNotification {
	level?: number;
	message?: string;
}

export const NOTIFICATION_TYPE_SPLASH = "splash";
export const NOTIFICATION_TYPE_BANNER = "banner";
export const POLLING_INTERVAL = 60 * 60 * 1000;

export const notificationActive = (level: number) => ({
	splash: Boolean(level && level >= 1 && level <= 2),
	banner: Boolean(level && level >= 2 && level <= 3),
});

export const cleanNotificationMessage = (message?: string) => {
	if (!message) {
		return "";
	}

	return StringUtils.cleanHTMLString(message, {
		ALLOWED_TAGS: ["b", "a", "i"],
	});
};
